import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { OidcPaths } from "../utils/oidcRoutes";
import { OidcSessionLost } from "./OidcStateComponents";

export interface SessionLostViewProps {
  oidcPaths: OidcPaths;
}

export const SessionLostView: FC<SessionLostViewProps> = ({ oidcPaths }) => {
  const navigate = useNavigate();

  useEffect(
    () => navigate("/" + oidcPaths.logout),
    [navigate, oidcPaths.logout],
  );

  return (<OidcSessionLost/>);
};
